var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","stripe":""},scopedSlots:_vm._u([{key:"permission_data",fn:function(ref){
var row = ref.row;
return [_c('ul',{staticClass:"ts-list-disc"},[_c('li',[_vm._v("Trial Balance")]),_c('li',[_vm._v("Balance Sheet")]),_c('li',[_vm._v("Profit and Loss")])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }